import * as types from './action-types';

export function setPaletteVariation(name, variation) {
  return {
    type: types.SET_PALETTE_VARIATION,
    payload: {name, variation},
  }
}


// WEBPACK FOOTER //
// ./src/core/palettes/actions.js